module.exports = __webpack_public_path__ + "static/media/ks_swiper_x.ea153fa7.jpg";